import { ChangeDetectionStrategy, Component, input, model, output} from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { VOrder } from '../../models/vorder.model';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { SortingModel } from 'src/app/features/shared/models/sorting.model';
import { OrdineWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-orders-table',
  providers:[],
  imports: [TableModule, Tag],
  templateUrl: './orders-table.html'
})

export class OrdersTableComponent extends AbstractComponent{
    items = input.required<VOrder[]>();
    onSelect = output<VOrder>();
    clientApiEnum= EntityApiEnum.CLIENT;
    sorting = model.required<SortingModel>();

    sort(event: any){
      this.sorting.set({ orderByClause: event.field, orderDirection: event.order === 1 ? 'asc' : 'desc' });
    }

    getOrderStatusSeverity(stateId:number): 'secondary' | 'success' | 'info' | 'warn' | 'danger' {
      return OrdineWorkflow.find(x => x.id == stateId)?.severity ?? 'info';
    }

    getOrderStatusDescription(stateId:number): string | undefined {
      return OrdineWorkflow.find(x => x.id == stateId)?.label;
    } 

}
  

